<template>
  <div class="chat">
    <ChatLoading v-if="isLoading" />

    <ChatErrorConnection
      v-if="isConnectionError && !isLoading"
      @reconnect="startConnection"
    />

    <div v-if="isReady" class="chat__messages" ref="messages">
      <ChatMessages :messages="messages" />
    </div>

    <div v-if="isReady" class="chat__message-form">
      <ChatForm
        ref="form"
        :user="user"
        :disabled="!user.id"
        :readonly="isMesseageLoading"
        :error-message="errorMessage"
        @send-message="sendMessage"
      >
        <template #disabled>Apenas membros CyberClass podem participar do chat. <a href="#" @click.prevent="openAuthModal">Clique para criar sua conta grátis!</a></template>
      </ChatForm>
    </div>
  </div>
</template>

<script>
import ChatMessages from '@/components/chat/ChatMessages'
import ChatForm from '@/components/chat/ChatForm'
import ChatLoading from '@/components/chat/ChatLoading'
import ChatErrorConnection from '@/components/chat/ChatErrorConnection'
import AuthFormModal from '@/components/modals/auth/AuthFormModal'

export default {
  components: {
    ChatMessages,
    ChatForm,
    ChatLoading,
    ChatErrorConnection,
  },

  props: {
    token: { type: String, default: null },
    user: { type: Object, default: null },
    live: { type: Object, default: () => ({})},
    hasSubscriptionAccess: { type: Boolean, default: false }
  },

  data: () => ({
    messages: [],
    connection: null,
    isLoading: true,
    isMesseageLoading: false,
    isConnectionError: false,
    errorMessage: null,
    errorMessageTimeout: null,
  }),

  mounted() {
    console.log('user', this.user)
    this.startConnection()
  },

  computed: {
    isReady() {
      return !this.isLoading && this.connection
    }
  },

  watch: {
    errorMessage() {
      if (this.errorMessageTimeout) {
        clearTimeout(this.errorMessageTimeout)
      }

      this.errorMessageTimeout = setTimeout(() => this.errorMessage = null, 5000)
    }
  },

  methods: {
    openAuthModal () {
      this.$modal.show(AuthFormModal, { defaultTab: 'sign-up' }, { width: '343px' }, {
        'closed': () => this.$store.commit('auth/resetModal')
      })
    },

    startConnection() {
      this.isLoading = true

      this.connection = new WebSocket(process.env.VUE_APP_WEBSOCKET_URL)

      this.isConnectionError = false

      this.connection.addEventListener('open', () => {
        this.connection.send(JSON.stringify({
          action: 'AUTHENTICATE',
          token: this.token,
          liveId: this.live.id
        }))
      })

      this.connection.addEventListener('message', event => {
        const payload = JSON.parse(event.data)
        console.log('recebido', payload)

        if (payload.action === 'AUTHENTICATE') {
          this.isLoading = false
        }

        if (payload.action === 'OLD_MESSAGES') {
          this.messages = payload.payload.messages

          this.$nextTick(() => {
            let div = this.$refs.messages
            div.scrollTop = div.scrollHeight
          })
        }

        if (payload.action === 'NEW_MESSAGE') {
          let div = this.$refs.messages

          this.messages.push(payload.payload)

          if (div.scrollHeight - div.scrollTop === div.clientHeight) {
            this.$nextTick(() => {
              div.scrollTop = div.scrollHeight
            })
          }
          
        }

        if (payload.action === 'MESSAGE_POSTED') {
          this.$refs.form.clearMessage()
          this.isMesseageLoading = false
        }

        if (payload.action === 'ERROR') {
          this.errorMessage = payload.payload.error
          this.isMesseageLoading = false
        }
      })

      this.connection.addEventListener('close', () => {
        this.isLoading = false
        this.isConnectionError = true
      })
    },

    sendMessage(message) {
      this.errorMessage = null

      this.isMesseageLoading = true

      this.connection.send(JSON.stringify({
        action: 'POST_MESSAGE',
        token: this.token,
        liveId: this.live.id,
        payload: { message }
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
  .chat {
    position: relative;
    background: #39c;
    display: flex;
    flex-direction: column;
    height: 600px;
    border-top: 0;

    @media(min-width: 992px) {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }

    &__messages {
      padding: 14px;
      background: #EDEDED;
      flex: 1;
      overflow: auto;
    }

    &__message-form {
      padding: 14px;
      background: #fff;
      border-top: 1px solid #E2E2E2;
    }
  }
</style>